import RandingStyle20 from "../../randing/RandingStyle20";

function Randing221({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle20
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/221/1-1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/221/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/221/3-1.jpg`}
      qOptionColor="blue"
      qTitleColor="#204cec"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      randingNumber="221"
    />
  );
}

export default Randing221;
